import { useRef, useState, type ChangeEvent, type KeyboardEvent } from 'react'
import { Send24Regular } from '@fluentui/react-icons'
import styles from './PromptComposer.module.css'

interface PromptComposerProps {
  onSend: (text: string) => void
  disabled: boolean
}

export function PromptComposer({ onSend, disabled }: PromptComposerProps) {
  const [value, setValue] = useState('')
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  const handleSend = () => {
    const trimmed = value.trim()
    if (!trimmed || disabled) return
    onSend(trimmed)
    setValue('')
    if (textareaRef.current) textareaRef.current.style.height = 'auto'
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      handleSend()
    }
  }

  const handleInput = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setValue(event.target.value)
    const el = event.target
    el.style.height = 'auto'
    el.style.height = `${Math.min(el.scrollHeight, 160)}px`
  }

  return (
    <div className={styles.root}>
      <div className={styles.inputRow}>
        <label htmlFor="soc-copilot-composer" className="visually-hidden">
          Întreabă SOC-Copilot
        </label>
        <textarea
          id="soc-copilot-composer"
          ref={textareaRef}
          className={styles.textarea}
          placeholder="Întreabă despre un incident, utilizator sau endpoint..."
          rows={1}
          value={value}
          disabled={disabled}
          onChange={handleInput}
          onKeyDown={handleKeyDown}
        />
        <button
          type="button"
          className={styles.sendButton}
          onClick={handleSend}
          disabled={disabled || value.trim().length === 0}
          aria-label="Trimite mesajul"
        >
          <Send24Regular />
        </button>
      </div>
      <p className={styles.footnote}>Read-only investigation • Human-controlled response</p>
    </div>
  )
}
